export const ImageModal = () => ({
  showModal: false,
  modalImageSrc: '',

  openModal(imageUrl) {
    this.modalImageSrc = imageUrl;
    this.showModal = true;
    this.$refs.modal.showModal();
  },

  closeModal() {
    this.showModal = false;
    this.$refs.modal.close();

    setTimeout(() => {
      this.modalImageSrc = '';
    }, 200);
  }
})
